module.exports = __webpack_public_path__ + "static/media/successful_purchase.cae41495.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/successful_purchase.svg
// module id = 1085
// module chunks = 2